import { Button, Dialog, DialogContent } from '@mui/material';
import React from 'react';

import { Lab } from 'api/labs';
import { DialogChromeFooter, DialogChromeHeader } from 'components/atoms/Dialog/DialogChrome';
import { CreateLabForm } from './CreateLabForm';

interface CreateLabDialogProps {
  existingLabs: Lab[];
  onClose: () => void;
  open: boolean;
}

export const CreateLabDialog: React.FC<CreateLabDialogProps> = ({ existingLabs, onClose, open }) => {
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="create-lab-dialog-title" data-testid="create-lab-dialog">
      <DialogChromeHeader
        title="Create Lab"
        titleId="create-lab-dialog-title"
        closeButtonAriaLabel="Close create lab dialog"
        onClose={onClose}
      />
      <DialogContent dividers>
        <CreateLabForm existingLabs={existingLabs} />
      </DialogContent>
      <DialogChromeFooter>
        <Button onClick={onClose} sx={{ mt: 2 }} data-testid="create-lab-close-button">
          Close
        </Button>
      </DialogChromeFooter>
    </Dialog>
  );
};
